export const excelColor = "#007A33";
export const pdfColor = "#D32F2F";
export const primaryColor = "#2378B3";
export const secondaryColor = "#E9852D";
